import { api, TokenProvider } from '@src/main/modules/common/common/infrastructure/http/axios';
import { Link } from '@src/main/modules/common/link/domain/Link';
import { LinkRepository } from '@src/main/modules/common/link/domain/LinkRepository';
import { LinkResponse } from '@src/main/modules/common/link/infrastructure/LinkResponse';

export const createLinkHttpRepository = (tokenProvider: TokenProvider): LinkRepository =>
  new LinkHttpRepository(tokenProvider);

class LinkHttpRepository implements LinkRepository {
  private readonly tokenProvider: TokenProvider;

  constructor(tokenProvider: TokenProvider) {
    this.tokenProvider = tokenProvider;
  }

  async findLink(): Promise<Link> {
    const token = await this.tokenProvider.getToken();
    const response = await api.get<LinkResponse>('/link', token);
    return response;
  }

  async updateLink(link: Link): Promise<void> {
    const token = await this.tokenProvider.getToken();
    await api.put('/link', token, link);
  }
}
